export default "__VITE_PUBLIC_ASSET__4e3fbd6b__"